import type { EChartsOption, GraphicComponentOption } from "echarts";
import EChartBase from "./EChartBase";
import { defaultChartColors, toneColor } from "./ChartTheme";

export type DonutDatum = {
  label: string;
  value: number;
  tone?: string;
  [key: string]: any;
};

type Props = {
  data: DonutDatum[];
  height?: number | string;
  centerLabel?: string;
  onItemClick?: (item: DonutDatum) => void;
};

export default function DonutChart({ data, height = 300, centerLabel, onItemClick }: Props) {
  const graphic: GraphicComponentOption[] = centerLabel
  ? [
      {
        type: "text",
        left: "center",
        top: "42%",
        style: {
          text: centerLabel,
          textAlign: "center",
          fill: "#163A5F",
          fontSize: 13,
          fontWeight: 700,
        },
        // style: {
        //   text: `{value|${centerValue}}\n{name|${centerLabel}}`,
        //   rich: {
        //     value: {
        //       fontSize: 16,
        //       fontWeight: 700,
        //       fill: "#163A5F",
        //     },
        //     name: {
        //       fontSize: 11,
        //       fill: "#6B7280",
        //     },
        //   },
        //   textAlign: "center",
        // },
      } as any,
    ]
  : [];

  const option: EChartsOption = {
    color: defaultChartColors,
    tooltip: { trigger: "item" },
    legend: { bottom: 0, type: "scroll" },
    graphic: graphic,
    series: [
      {
        type: "pie",
        radius: ["45%", "70%"],
        center: ["50%", "43%"],
        label: { formatter: "{b}: {d}%" },
        data: data.map((x) => ({
          name: x.label,
          value: x.value,
          itemStyle: x.tone ? { color: toneColor(x.tone) } : undefined,
          raw: x,
        })),
      },
    ],
  };

  return (
    <EChartBase
      option={option}
      height={height}
      empty={!data?.length}
      onItemClick={(p) => onItemClick?.(p.data?.raw)}
    />
  );
}